<template>
    <!-- 储值订单管理 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'storedValueOrder')">
        <div slot="header">
            <a-form :form="form" layout="inline" class="store-one-form">
                <a-form-item label="会员手机号">
                    <a-input placeholder="请输入" v-decorator="['phone']" ></a-input>
                </a-form-item>
                <a-form-item label="订单状态">
                    <a-select allowClear placeholder="请选择" v-decorator="['tradeState']" >
                        <a-select-option value="1">待支付</a-select-option>
                        <a-select-option value="2">已支付</a-select-option>
                        <a-select-option value="3">支付失败</a-select-option>
                        <a-select-option value="4">退款中</a-select-option>
                        <a-select-option value="6">全部退款</a-select-option>
                        <a-select-option value="7">已关闭</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="支付方式">
                    <a-select allowClear placeholder="请选择" v-decorator="['payMode']" >
                        <template v-for="(item,index) in $utils.payMode">
                            <a-select-option :key="index" :value="index">{{item}}</a-select-option>
                        </template>
                    </a-select>
                </a-form-item>
                <a-form-item label="充值金额">
                    <a-input-group compact >
                        <a-input class="range-input range-input-left" placeholder="最小充值金额" v-decorator="['minPayAmount']" />
                        <a-input style="width: 40px; border-left: 0; pointer-events: none; backgroundColor: #fff" placeholder="~" disabled />
                        <a-input class="range-input range-input-right" placeholder="最大充值金额" v-decorator="['maxPayAmount']" />
                    </a-input-group>
                </a-form-item>
                <a-form-item label="人工确认">
                    <a-select allowClear placeholder="请选择" v-decorator="['isManualPayment']">
                        <a-select-option value="true">是</a-select-option>
                        <a-select-option value="false">否</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="下单时间">
                    <a-range-picker
                        style="width:282px"
                        format="YYYY/MM/DD"
                        v-decorator="['orderTime']"
                    />
                </a-form-item>
                <a-form-item label="支付时间">
                    <a-range-picker
                        style="width:282px"
                        format="YYYY/MM/DD"
                        v-decorator="['payTime']"
                    />
                </a-form-item>
                <a-form-item class="wrap-header-button">
                    <a-button @click="search" :loading="searchLoading" class="mr8" type="primary">筛选</a-button>
                    <a-button @click="handleReset">重置</a-button>
                </a-form-item>
            </a-form>
        </div>
        <div class="wrap-container-in">
            <a-table :scroll="{x:800}" :loading="searchLoading" bordered :dataSource="dataSource" :columns="columns" :pagination="pagination" @change="changePage" :rowKey="(record, index) => index">
                <span slot="orderTime" slot-scope="orderTime">{{orderTime}}</span>
                <span slot="platformName" slot-scope="platformName, row">{{platformName != "收银台" ? platformName : row.shopName || "-"}}</span>
                <span slot="payTime" slot-scope="a,row">{{row.payTime ? row.payTime : "-"}}</span>
                <span slot="amount" slot-scope="amount,row">{{row.activity ? '0.00' : (amount ? amount : '0.00')}}</span>
                <span slot="rechargeAmount" slot-scope="rechargeAmount">{{rechargeAmount ? rechargeAmount : '0.00'}}</span>
                <span slot="category" slot-scope="category,row">{{row.activity ? '活动赠送' : (category ? category : "-")}}</span>
                <span slot="payMode" slot-scope="a,row">{{$utils.payMode[row.payMode] || "-"}}</span>
                <span slot="isManualPayment" slot-scope="a, row">{{row.isManualPayment ? '是' : "否"}}</span>
                <span slot="action" slot-scope="a, row">
                    <span v-if="getBtnByAuth('storedValueDetail')">
                        <a class="text-primary" @click="storedValueDetail(row.tradeNo, row.tradeState)">订单详情</a>
                    </span>
                </span>
            </a-table>
        </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>
<script type="text/javascript">
    import { mapGetters } from "vuex";
    import moment  from 'moment';
    const columns = [
    {
        title: "交易订单号",
        dataIndex: "tradeNo"
    },
    {
        title: "会员手机号",
        dataIndex: "phone"
    },
    {
        title: "订单状态",
        dataIndex: "tradeState"
    },
    {
        title: "充值金额/元",
        dataIndex: "rechargeAmount",
        scopedSlots: { customRender: "rechargeAmount" }
    },
    {
        title: "购买类型",
        dataIndex: "category",
        scopedSlots: { customRender: "category" }
    },
    {
        title: "购买途径",
        dataIndex: "platformName",
        scopedSlots: { customRender: "platformName" }
    },
    {
        title: "下单时间",
        dataIndex: "orderTime",
        scopedSlots: { customRender: "orderTime" }
    },
    {
        title: "订单金额/元",
        dataIndex: "orderAmount",
        scopedSlots: { customRender: "amount" }
    },
    {
        title: "支付时间",
        dataIndex: "payTime",
        scopedSlots: { customRender: "payTime" }
    },
    {
        title: "支付金额/元",
        dataIndex: "payAmount",
        scopedSlots: { customRender: "amount" }
    },
    {
        title: "支付方式",
        dataIndex: "payMode",
        scopedSlots: { customRender: "payMode" }
    },
    {
        title: "是否人工确认",
        dataIndex: "isManualPayment",
        scopedSlots: { customRender: "isManualPayment" }
    },
    {
        title: "操作",
        key: "action",
        scopedSlots: { customRender: "action" }
    }]
    export default {
        name: "mealOrder",
        components: {},
        props: {},
        data() {
            return {
                columns,
                dataSource: [],
                shopList: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                searchLoading: false
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        methods: {
            moment,
            changePage(page) {
                this.pagination.pageSize = page.pageSize
                this.pagination.current = page.current
                this.getList()
            },
            handleReset() {
                this.form.resetFields();
                this.pagination.current = 1;
                this.pagination.pageSize = 20;
                this.getList();
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            getShopList() {
                this.$api.totalPlatform.selectList().then(res => {
                    let shopIdList = this.$userInfoTool.getUser().shopIdList;
                    this.shopList = res.filter(i => {
						return shopIdList.find($i => {
							return $i === i.id;
						})
					});
                    if (shopIdList.find(el => el == -1)) {
                        this.shopList = res;
                        return;
                    }
                });
            },
            // 获取购票订单列表
            getList() {
                if (this.searchLoading) {
                    return false;
                }
                if (!this.shopId) return;
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const orderTime = values['orderTime'] ? values['orderTime'] : []
                    values.minOrderTime = orderTime.length > 0 ? orderTime[0].format('YYYY-MM-DD') : undefined
                    values.maxOrderTime = orderTime.length > 0 ? orderTime[1].format('YYYY-MM-DD') : undefined

                    const payTime = values['payTime'] ? values['payTime'] : []
                    values.minPayTime = payTime.length > 0 ? payTime[0].format('YYYY-MM-DD') : undefined
                    values.maxPayTime = payTime.length > 0 ? payTime[1].format('YYYY-MM-DD') : undefined

                    delete values['orderTime']
                    delete values['payTime']
                    this.searchLoading = true;
                    this.$api.order.orderSearch({
                        query: Object.assign(values, 
                        {   
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize,
                            goodsType: "BALANCE"
                        })
                    })
                    .then(res => {
                        this.searchLoading = false;
                        this.pagination.total = res.total;
                        this.dataSource = res.list;
                    }).catch(err => {
                        this.searchLoading = false;
                    });
                });
            },
            storedValueDetail(orderId, tradeState) {
                this.$router.push({
                    name: 'storedValueDetail',
                    query: {orderId: orderId, tradeState: tradeState}
                })
            }

        },
        created() {},
        mounted() {
            setTimeout(() => {
                this.getShopList()
                this.getList()
            }, 500);
        },
        watch: {
            '$route'(val) {
                val.name == 'storedValueOrder' && this.getList();
            },
            'shopId'(val) {
                this.getList();
            }
        }
    };
</script>
<style lang="scss">
</style>